import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const SliderWrapper = styled.div`
  position: relative;

  .slick-slider {
    padding: 20px 50px;
    ${mediaQuery('tablet')} {
      padding: 20px 0px;
    }
  }

  .slick-dots {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    display: flex !important;
    flex-wrap: nowrap;
    justify-content: center;
  }

  ${mediaQuery('desktop')} {
    margin-bottom: 20px;
  }
`;

export const ButtonWrapper = styled.div<{ isRight?: boolean; whiteArrows?: boolean }>`
  height: 100%;
  font-weight: 600;
  font-size: 24px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  padding: 10px;

  color: ${(props) => (props.whiteArrows ? 'white' : 'default')};

  ${(props) => (props.isRight ? 'right: 0px' : 'left: 0x')};

  ${mediaQuery('desktop')} {
    display: none !important;
  }
`;
